import { useTranslation } from "react-i18next";

const About = () => {
  const { t, i18n } = useTranslation();
  const englishVideoSrc = "/images/Care-and-therapy-English-web.mp4";
  const danishVideoSrc = "/images/Omsorgsterapi dk Version 1,2.mp4";
  const videoPosterSrc = "/images/JK.jpeg";
  const isEnglishVideo = i18n.resolvedLanguage?.startsWith("en");
  const videoSrc = isEnglishVideo ? englishVideoSrc : danishVideoSrc;

  return (
    <section id="om-omsorgsterapi" className="bg-[#F7FBFA] pt-10 pb-6 sm:pt-14 sm:pb-8">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="mx-auto max-w-6xl">
          <h2 className="mb-8 text-center text-2xl font-semibold text-[#006B5F] sm:mb-10 sm:text-4xl">
            {t("about.helpTitle")}
          </h2>

          <div className="grid gap-6 sm:gap-8 lg:grid-cols-[0.9fr_minmax(0,1.1fr)] lg:items-start">
            <div className="flex">
              <div className="aspect-video w-full overflow-hidden rounded-[18px] border border-[#006B5F]/15 bg-white shadow-sm sm:min-h-[360px] sm:rounded-[20px] lg:h-[430px] lg:aspect-auto xl:h-[460px]">
                <video
                  key={videoSrc}
                  controls
                  preload="metadata"
                  poster={videoPosterSrc}
                  playsInline
                  controlsList="nofullscreen noremoteplayback"
                  disablePictureInPicture
                  disableRemotePlayback
                  className="h-full w-full object-cover"
                >
                  <source src={videoSrc} type="video/mp4" />
                  {t("about.videoFallback")}
                </video>
              </div>
            </div>

            <div className="rounded-[18px] bg-[#3E7B72] p-5 text-white shadow-sm sm:rounded-[20px] sm:p-8 lg:min-h-[430px] xl:min-h-[460px]">
              <h3 className="text-[1.35rem] font-semibold leading-tight sm:text-[1.85rem]">
                {t("about.elements.title")}
              </h3>

              <div className="mt-6 space-y-6 sm:mt-7 sm:space-y-7">
                <div className="flex items-start gap-4">
                  <div className="mt-2 h-2.5 w-2.5 rounded-full bg-white" />
                  <div>
                    <h4 className="text-lg font-semibold leading-tight sm:text-[1.15rem]">
                      {t("about.elements.listening.title")}
                    </h4>
                    <p className="mt-2 text-[1rem] leading-7 text-white/90 sm:text-[1.08rem] sm:leading-8">
                      {t("about.elements.listening.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="mt-2 h-2.5 w-2.5 rounded-full bg-white" />
                  <div>
                    <h4 className="text-lg font-semibold leading-tight sm:text-[1.15rem]">
                      {t("about.elements.acceptance.title")}
                    </h4>
                    <p className="mt-2 text-[1rem] leading-7 text-white/90 sm:text-[1.08rem] sm:leading-8">
                      {t("about.elements.acceptance.description")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="mt-2 h-2.5 w-2.5 rounded-full bg-white" />
                  <div>
                    <h4 className="text-lg font-semibold leading-tight sm:text-[1.15rem]">
                      {t("about.elements.care.title")}
                    </h4>
                    <p className="mt-2 text-[1rem] leading-7 text-white/90 sm:text-[1.08rem] sm:leading-8">
                      {t("about.elements.care.description")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
